// App.js
import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './Pages/LoginPage.js';
import ClientsPage from './Pages/ClientsPage';
import ProductPage from 'Pages/ProductPage/ProductPage.js';
import CheckoutPage from './Pages/CheckoutPage.js';
import Navbar from './Components/NavBar.js';
import { OrderProvider } from './Context/OrderContext.js';
import { AuthProvider } from './Context/AuthContext';
import ProtectedRoute from './Components/ProtectedRoutes.js';
import 'App.css'

function App() {
  // State to notify ProductPage about reset events
  const [resetSignal, setResetSignal] = useState({ tab: null, reset: false });

  // This function will be called by Navbar on tab clicks
  const handleNavTabClick = (tab, reset) => {
    if (reset) {
      setResetSignal({ tab, reset: true });
    } else {
      setResetSignal({ tab: null, reset: false });
    }
  };

  return (
    <AuthProvider>
      <OrderProvider>
        <Router>
          {/* Pass handler to Navbar */}
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/clients"
              element={
                <ProtectedRoute>
                  <Navbar onTabClick={handleNavTabClick} />
          <ClientsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/products"
              element={
                <ProtectedRoute>
                  <Navbar onTabClick={handleNavTabClick} />
                  {/* Pass resetSignal to ProductPage */}
                  <ProductPage resetSignal={resetSignal} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cart"
              element={
                <ProtectedRoute>
                  <Navbar onTabClick={handleNavTabClick} />
                  <CheckoutPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </OrderProvider>
    </AuthProvider>
  );
}

export default App;
